import styled from 'styled-components';
import { colors } from 'styles/colors';
import { shadows } from 'styles/remoteControlShadows';
import { primaryScrollbar } from 'styles/scrollbar';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 162px;
`;

export const Base = styled.div<{ selected: boolean, open: boolean }>`
  height: 33px;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  user-select: none;
  cursor: pointer;

  & > svg {
    flex-shrink: 0;
  }

  ${({ selected }) => (selected ? `
    border-color: ${colors.stroke['primary-base']};
    background-color: ${colors.brand.primary.lighter};
  ` : `
    border-color: ${colors.stroke['soft-200']};
    background-color: ${colors.bg['white-0']};
  `)}

  ${({ open }) => (open ? `
    border-color: ${colors.stroke['primary-base']};
    border-bottom-color: ${colors.bg['white-0']};
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  ` : '')}

`;

export const Label = styled.span<{ selected: boolean }>`
  margin-top: 2px;
  font-weight: 600;
  font-size: 11px;
  line-height: 150%;
  color: ${({ selected }) => (selected ? colors.text['primary-base'] : colors.text['main-900'])};
`;

export const List = styled.div`
  width: 100%;
  min-height: 40px;
  max-height: 364px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 1px 0;
  overflow-y: auto;

  ${primaryScrollbar}
`;

export const ListContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 100%;
  z-index: 2;
  background-color: ${colors.bg['white-0']};
  box-shadow: ${shadows.shadow01};
  border: 1px solid ${colors.stroke['primary-base']};
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  padding: 5px 0px;
  overflow: hidden;
`;

export const InputSearchStyle = styled.input`
  width: 100%;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 11px;
  border: 1px solid ${colors.GreyBorderSoft};
  outline: none;
`;

export const ListItem = styled.div<{selected: boolean, comingSoon?: boolean}>`
  cursor: pointer;
  padding: 4px 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  background-color: ${({ selected }) => (selected ? colors.brand.primary.lighter : colors.bg['white-0'])};
  user-select: none;

  &:hover {
    background-color: ${colors.brand.primary.lighter};
  }

  ${({ comingSoon }) => comingSoon && `
      opacity: 0.6;
      pointer-events: none;
    `}

  & > span {
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: ${colors.Black};
  }
`;

export const BorderIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.bg['white-0']};
  border: 1px solid ${colors.stroke['sub-300']};
  border-radius: 9999px;
  flex-shrink: 0;
`;

export const ContainerClearFilters = styled.div`
  padding: 8px;
  cursor: pointer;

  path {
    stroke: ${colors.icon['primary-base']};
  }

  svg:hover {
    path {
      stroke: ${colors.stroke['sub-300']};
    }
  }
  @media (max-width: 768px) {
    grid-column: -3 / -1 !important;
    justify-self: center;
  }
`;
